
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Analytics from '@/lib/analytics';

export function usePageTracking() {
  const location = useLocation();
  
  useEffect(() => {
    try {
      // Get the page name from the path
      const pageName = location.pathname === '/' 
        ? 'Home' 
        : location.pathname
            .split('/')
            .filter(Boolean)
            .map(segment => segment.charAt(0).toUpperCase() + segment.slice(1))
            .join(' ');
      
      // Extract query parameters for better tracking
      const searchParams = new URLSearchParams(location.search);
      const queryParams: Record<string, string> = {};
      
      // Collect query parameters for analytics
      for (const [key, value] of searchParams.entries()) {
        queryParams[key] = value;
      }
      
      // Enhanced page view tracking with URL data
      Analytics.pageView(pageName, {
        path: location.pathname,
        search: location.search,
        queryParams,
        fullUrl: window.location.href,
        referrer: document.referrer || 'direct'
      });
      
      // Track page load time for Core Web Vitals monitoring
      if (window.performance) {
        setTimeout(() => {
          const perfData = window.performance.timing;
          const pageLoadTime = perfData.loadEventEnd - perfData.navigationStart;
          
          if (pageLoadTime > 0) {
            Analytics.track('Page Load Performance', {
              page: pageName,
              loadTimeMs: pageLoadTime,
              url: window.location.href
            });
          }
        }, 0);
      }
      
      console.log(`[Analytics] Page tracking triggered for: ${pageName}`);
    } catch (error) {
      console.error('[Analytics] Error in page tracking:', error);
    }
  }, [location]);
}

export function useAnalytics() {
  return Analytics;
}

export default useAnalytics;
